import styled from 'styled-components';
import { grey } from 'styles/Colors';

export const BaseRunnerWrapper = styled.div`
  font-size: 13px;
`;

export const TeamName = styled.div`
  font-size: 11px;
  color: ${grey};
`;

export const InitialState = styled.div`
  opacity: 0.5;
  font-size: 12px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const Divider = styled.div`
  margin-top: 3px;
  margin-bottom: 3px;
  border-bottom: 1px solid #e0e0e0;
  height: 0px;
  width: 100%;
`;

export const FinalState = styled.div`
  font-size: 15px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;
